<div class="fui-layout-container">
  <!--
    Hero header (2026-09-01) — adopts the reusable `<fui-layout-header>` hero API.
    Placeholder image is one of the shipped fui-hero assets; swap for a My-Gear-specific
    image later. `heroTheme: 'dark'` = light text over a dark photo; the light-mode mask
    logic in `_fender-ui.scss` kicks in automatically when the viewer is in light theme.
  -->
  <fui-layout-header [breadcrumbs]="breadcrumbs" headingText="fui-header.my_gear" [description]="'newdash.fender_gear_description'" heroImageUrl="/assets/images/hero/fui-hero11.jpg" heroTheme="dark">
    <!--
      Category nav-pills hidden 2026-09-01 — the same categories are already listed in
      the sidebar filter opened by the hamburger, so the pill row was duplicating them.
      Commented out (not deleted) so we can put it back easily if we want the top-level
      category shortcut back later.
    -->
    @if (false && hasProducts) {
      <div class="fui-nav-pills m-t-30">
        <ul>
          <li>
            <button
              [class.active]="selectedProductCategory?.string_id == 'all'"
              (click)="appService.mobileMenuShown = false; selectProductCategory('all')"
              (keyup.enter)="appService.mobileMenuShown = false; selectProductCategory('all')"
              (keyup.space)="appService.mobileMenuShown = false; selectProductCategory('all')"
            >
              {{ "newdash.all" | translate }}
            </button>
          </li>
          @for (category of displayedProductCategories; track category) {
            <li>
              @if (category.count) {
                <button
                  [class.active]="selectedProductCategory?.string_id == category.string_id"
                  (click)="appService.mobileMenuShown = false; selectProductCategory(category)"
                  (keyup.enter)="appService.mobileMenuShown = false; selectProductCategory(category)"
                  (keyup.space)="appService.mobileMenuShown = false; selectProductCategory(category)"
                >
                  {{ category.languages[helperService.selectedLanguage.code] }}
                </button>
              }
            </li>
          }
        </ul>
      </div>
    }
    <!--
      Full action row projected into the hero (2026-09-01) — replaces the old two-row
      layout (search on top, hr, sort/view/results/refresh below). Now everything lives
      inside the hero:
        - Left cluster: search-only content-filter + hamburger (matches community-detail).
        - Right cluster: sort / view / results / refresh (`showSearchInput=false`).
      `.fui-hero-actions-row { flex-wrap: wrap }` lets the two clusters wrap onto their
      own lines once the viewport is too narrow — search-wrap keeps a 300px minimum so
      it drops down cleanly before it gets uncomfortably squeezed.
    -->
    @if (hasProducts && sharedProductsListCmp && sharedProductsListCmp.allProducts?.length > 1) {
      <div class="fui-hero-actions-row d-flex align-items-center">
        <!--
          `.fui-hero-actions-search-wrap` (flex: 1 1 300px; max-width: 600px) is the
          growable "search slot" — it fills the row's remaining space up to 600px and
          shrinks as the viewport narrows. The hamburger sits OUTSIDE this wrapper (as
          its own flex sibling) so the wrap doesn't turn into an inner flex row that
          would collapse the content-filter to its intrinsic width. This mirrors the
          community-detail markup shape exactly.
        -->
        <div class="fui-hero-actions-search-wrap">
          <fui-content-filter
            [showViewOption]="false"
            [showSidebarToggle]="false"
            [showSortOptionsToggle]="false"
            [showResults]="false"
            [showRefreshButton]="false"
            [activeQuery]="sharedProductsListCmp.filterQuery"
            (clearQuery)="sharedProductsListCmp.filterQuery = ''; sharedProductsListCmp.filterProducts('')"
            (queryChanged)="sharedProductsListCmp.filterQuery = $event; sharedProductsListCmp.filterProducts($event)"
          ></fui-content-filter>
        </div>
        <button type="button" class="fa-button fui-hamburger-btn" placement="bottom" [ngbTooltip]="'Filters'" aria-label="Show filters" (click)="toggleFilters()">
          <fa-icon icon="bars" class="action circle-icon-btn"></fa-icon>
        </button>
        <fui-content-filter
          class="fui-hero-actions-secondary"
          [showSearchInput]="false"
          [showSidebarToggle]="false"
          [showRefreshButton]="true"
          [refreshing]="sharedProductsListCmp.refreshing"
          [resultsCount]="sharedProductsListCmp.selectedCategory?.count || sharedProductsListCmp.allProducts?.length || 0"
          (sortChanged)="sharedProductsListCmp.sortProducts()"
          (clearFilter)="sharedProductsListCmp.clearFilter($event); sharedProductsListCmp.filter()"
          (refreshClicked)="sharedProductsListCmp.refresh()"
        ></fui-content-filter>
      </div>
    }
  </fui-layout-header>
  <div class="fui-layout-edge-content">
    <myp-shared-products-list
      class="h-full"
      #sharedProductsListCmp
      (registerClicked)="registerProduct()"
      (listLoaded)="listLoaded($event)"
      [selectedCategory]="selectedProductCategory"
      (categorySelected)="selectProductCategory($event)"
    ></myp-shared-products-list>
  </div>
  <div class="m-t-100 p-b-50">
    <fui-footer></fui-footer>
  </div>
</div>
